import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Field } from 'src/app/base/interfaces/field';

@Component({
    selector: 'app-password-confirmation',
    templateUrl: './password-confirmation.component.html',
    styleUrls: ['./password-confirmation.component.css']
})
export class PasswordConfirmationComponent implements OnInit {
    @Input() field: Field;
    @Input() fieldKey: string;
    @Input() formGroup: UntypedFormGroup;

    constructor() { }

    ngOnInit(): void {
    }

}
